module.exports = __webpack_public_path__ + "static/media/datatrack.5dcf8d51.svg";